var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftDrawerRoundtripOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1036",
    "data-name": "Group 1036",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25.82,
    viewBox: "0 0 25 25.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1546",
    "data-name": "Rectangle 1546",
    width: 5.546,
    height: 5.546,
    rx: 1,
    transform: "translate(21.079 16.831) rotate(-135)",
    fill: "#e13505"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1182",
    "data-name": "Path 1182",
    d: "M13.024,25.82a12.994,12.994,0,0,0,9.209-3.782,1.086,1.086,0,0,0,0-1.547,1.111,1.111,0,0,0-1.561,0A10.837,10.837,0,0,1,2.207,12.91,10.837,10.837,0,0,1,20.673,5.328a1.111,1.111,0,0,0,1.561,0,1.086,1.086,0,0,0,0-1.547A13.048,13.048,0,0,0,0,12.91,12.982,12.982,0,0,0,13.024,25.82Z",
    transform: "translate(0 0)",
    fill: "#e13505"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1183",
    "data-name": "Path 1183",
    d: "M0,4.832H4.84V0H2.816V2.808H0Z",
    transform: "translate(18.177 0.911)",
    fill: "#e13505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftDrawerRoundtripOrange);
export default __webpack_public_path__ + "static/media/left-drawer-roundtrip-orange.68a8abfd6b7686269a1b84bca93d7f6e.svg";
export { ForwardRef as ReactComponent };